<template>
  <div id="custom-hight-risk-upload">
    <!-- Proof of income -->
    <div class="columns">
      <div class="column">
        <label
          id="proof-income"
          class="label"
        >
          {{ $t('kyc.proof_of_income') }}
        </label>
        <label
          v-if="form.customerType === 'Personal'"
          class="subtitle-text"
        >
          ({{ $t('kyc.ex_proof_of_income_for_personal') }})
        </label>
        <label
          v-else
          class="subtitle-text"
        >
          ({{ $t('kyc.ex_proof_of_income_for_org') }})
        </label>
        <div class="example-img">
          <b-upload
            v-validate="'required'"
            v-model="form.proofOfIncome"
            name="proof income"
            accept="image/*,.pdf"
            drag-drop
            @input="(file) => onUploadDoc(file, 'proofOfIncome')"
          >
            <section
              class="section"
              data-test="kyc-upload-doc-hight-risk--proof-income"
            >
              <div class="content has-text-centered">
                <img
                  src="/static/img/icon-company-cer-doc.png"
                  class="dropzone-img--certificate"
                >
              </div>
              <div class="browse-btn">
                {{ $t('kyc.browse_file') }}
              </div>
            </section>
          </b-upload>
          <span class="is-invalid">{{ errors.first('proof income') }}</span>
          <b-tag
            v-if="form.proofOfIncome"
            type="is-primary"
          >
            {{ form.proofOfIncome.name }}
          </b-tag>
          <div
            v-if="proofOfIncomeOverSize"
            class="is-invalid t-al-center"
          >
            {{ $t('kyc.doc_limit') }} {{ limitFileSizeInMb }} MB
          </div>
        </div>
      </div>
    </div>
    <!-- Evidence of asset ownership -->
    <div class="columns">
      <div class="column">
        <label
          id="asset-ownership"
          class="label"
        >
          {{ $t('kyc.evidence_assets') }}
        </label>
        <label class="subtitle-text">({{ $t('kyc.ex_evidence_assets') }})</label>
        <div class="example-img">
          <b-upload
            v-validate="'required'"
            v-model="form.assetOwnership"
            name="asset ownership"
            accept="image/*,.pdf"
            drag-drop
            @input="(file) => onUploadDoc(file, 'assetOwnership')"
          >
            <section
              class="section"
              data-test="kyc-upload-doc-hight-risk--asset-ownership"
            >
              <div class="content has-text-centered">
                <img
                  src="/static/img/icon-company-cer-doc.png"
                  class="dropzone-img--certificate"
                >
              </div>
              <div class="browse-btn">{{ $t('kyc.browse_file') }}</div>
            </section>
          </b-upload>
          <span class="is-invalid">{{ errors.first('asset ownership') }}</span>
          <b-tag
            v-if="form.assetOwnership"
            type="is-primary"
          >
            {{ form.assetOwnership.name }}
          </b-tag>
          <div
            v-if="assetOwnershipOverSize"
            class="is-invalid t-al-center"
          >
            {{ $t('kyc.doc_limit') }} {{ limitFileSizeInMb }} MB
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { KYC_DOC_FILE_SIZE_LIMIT_IN_MB } from '@/constants'

export default {
  name: 'UploadDocumentHightRisk',
  inject: ['$validator'],
  props: {
    form: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      proofOfIncomeOverSize: false,
      assetOwnershipOverSize: false,
      limitFileSizeInMb: KYC_DOC_FILE_SIZE_LIMIT_IN_MB
    }
  },
  computed: {
    computedForm: function () {
      return Object.assign({}, this.form)
    }
  },
  watch: {
    computedForm: {
      handler: function (newVal, oldVal) {
        if ((oldVal.customerType === 'Personal' && newVal.career !== oldVal.career) || newVal.orgBusinessType !== oldVal.orgBusinessType) {
          delete this.form.proofOfIncome
          delete this.form.assetOwnership
        }
      },
      deep: true
    }
  },
  methods: {
    async onUploadDoc (file, key) {
      this[`${key}OverSize`] = false
      if ((file.size / 1000000) > this.limitFileSizeInMb) {
        this[`${key}OverSize`] = true
        this.form[key] = null
      }
    }
  }
}
</script>

<style lang="scss">
.kyc-information-is-expanded {
  .control {
    .select {
      width: 100%;
      select {
        width: 100%;
      }
    }
  }
}
#custom-hight-risk-upload {
  .upload .upload-draggable {
    width: 470px;
  }
  .tag {
    margin-top: 10px;
    span {
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

@media only screen and (max-width: 768px) {
  #custom-hight-risk-upload {
    .upload .upload-draggable {
      width: 100%;
    }
    .tag {
      width: 100%;
    }
  }
}
</style>

<style lang="scss" scoped>
.strong-text {
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.3px;
  color: #000000;
  margin-top: 30px;
  text-align: left;
}
.subtitle-text {
  font-size: 15px;
  font-weight: 500;
  line-height: 1.67;
  letter-spacing: 0.37px;
  color: #939393;
}
.example-img {
  text-align: center;
  margin: 20px 0 80px;
}
.dropzone-img {
  &--certificate {
    max-width: 173px;
    width: 100%;
  }
  &--shareholders {
    max-width: 420px;
    width: 100%;
  }
  &--attorney {
    max-width: 236px;
    width: 100%;
  }
}
.browse-btn {
  border-radius: 3px;
  background-color: #069bf9;
  max-width: 250px;
  padding: 13px;
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.37px;
  margin: 0 auto;
  text-align: center;
  cursor: pointer;
  margin-top: 20px;
}
.t-al-center {
  text-align: center;
}
@media only screen and (max-width: 768px) {
  .example-img {
    text-align: center;
    margin: 20px 0 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/KYC/components/UploadDocumentHightRisk.vue